import { useFormContext } from 'react-hook-form';

import { ServiceAgencyFormData } from '../RelatedService.schema';
import { CardColumn } from '../RelatedServiceCard';

type ServiceAgencyProps = {
  year: string;
};

export const ServiceAgency = ({ year }: ServiceAgencyProps) => {
  const { watch } = useFormContext<ServiceAgencyFormData>();

  const formData = watch();

  return (
    <div className="mt-4 flex flex-col gap-6 border-t border-neutral-800 pt-4">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <CardColumn
          label={`${year} Start Date`}
          text={formData.startDate ? new Date(formData.startDate).toLocaleDateString() : ''}
        />

        <CardColumn label="Provider Name" text={formData.providerName} />

        <CardColumn label="Provider Phone Number" text={formData.providerPhoneNumber} />
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <div />

        <CardColumn label="Agency Name" text={formData.agencyName} />

        <CardColumn label="Agency Phone Number" text={formData.agencyPhoneNumber} />
      </div>
    </div>
  );
};
